module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    class: _vm.headerClass,
    attrs: {
      "value": _vm.value
    },
    on: {
      "click": _vm.setSortOption
    }
  }, [_c('span', {
    class: _vm.isMin,
    attrs: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.checkSorted()) ? _c('v-icon', {
    attrs: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.sortIcon()))]) : _vm._e(), _vm._v(" "), (!_vm.checkSorted()) ? [_c('v-icon', {
    staticClass: "arrow_desc",
    attrs: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.orderByIcon[0]))]), _vm._v(" "), _c('v-icon', {
    staticClass: "arrow_asc",
    attrs: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.orderByIcon[1]))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35fe5c32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaignList/HeaderComp.vue
// module id = 840
// module chunks = 1